// extracted by mini-css-extract-plugin
module.exports = {"section":"e_UW","card":"e_VW"};